import { smallVesselCoeff } from "./coeffLoader";

const smallVesselCache = {};

export function predictSmallVesselSync(vesselType, lengthM, speedKn) {
    vesselType = vesselType.toLowerCase();
    if (vesselType.endsWith("s")) vesselType = vesselType.slice(0, -1);

    const cacheKey = `${vesselType}_${lengthM}_${speedKn}`;

    if (smallVesselCache[cacheKey]) {
        return smallVesselCache[cacheKey];
    }

    const df = smallVesselCoeff[vesselType];
    if (!df) return null;

    const ll = Math.log10(lengthM);
    const vv = Math.log10(speedKn);

    const freq = df.map((r) => r.Freq_Hz);
    const psdDb = df.map((r) =>
        r.b0_smooth +
        r.bL_smooth * ll +
        r.bV_smooth * vv +
        r.bLV_smooth * ll * vv
    );

    const factor = Math.pow(2, 1 / 6);

    function band(fc) {
        const fl = fc / factor;
        const fu = fc * factor;
        const h = (fu - fl) / 4;

        const nodes = [
            fl,
            fl + h,
            fl + 2 * h,
            fl + 3 * h,
            fu
        ];

        const interp = (f) => {

            if (f < freq[0]) {
                return psdDb[0];
            }

            for (let i = 0; i < freq.length - 1; i++) {
                if (freq[i] <= f && f <= freq[i + 1]) {
                    const t = (f - freq[i]) / (freq[i + 1] - freq[i]);
                    return psdDb[i] * (1 - t) + psdDb[i + 1] * t;
                }
            }

            return psdDb[psdDb.length - 1];
        };


        const psdLin = nodes.map((f) => Math.pow(10, interp(f) / 10));

        const P =
            (2 * h / 45) *
            (7 * psdLin[0] +
                32 * psdLin[1] +
                12 * psdLin[2] +
                32 * psdLin[3] +
                7 * psdLin[4]);

        return 10 * Math.log10(P);
    }

    const L63 = band(63);
    const L125 = band(125);

    let fc = 20;
    let totalLin = 0;
    const k = Math.pow(2, 1 / 3);

    while (fc <= 2000.1) {
        totalLin += Math.pow(10, band(fc) / 10);
        fc *= k;
    }

    const result = {
        L_63Hz_1_3: L63,
        L_125Hz_1_3: L125,
        L_20_2000Hz: 10 * Math.log10(totalLin)
    };

    smallVesselCache[cacheKey] = result;

    return result;
}
